import { FaBarsStaggered } from "react-icons/fa6";
import classes from "./Header.module.css";
import { FaHouse, FaFutbol, FaTrophy, FaClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../store/slices/languageSlice";

const Header = ({ active, hide }) => {
  const navigate = useNavigate();
  const { selectedLanguage } = useSelector((state) => state.languageSlice);
  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    if (selectedLanguage && i18n.language !== selectedLanguage) {
      i18n.changeLanguage(String(selectedLanguage));
    }
  }, [selectedLanguage, i18n]);

  return (
    <div className={classes.header}>
      <div className={classes.header_nav}>
        <div className={classes.logo_container}>
          <img
            src="assets/images/logo.png"
            alt="MyFootball XI"
            className={classes.logo}
          />
        </div>

        {/* <button type="button" className={classes.menu_button}>
                    <FaBarsStaggered className={classes.menu_bars} />
                </button> */}

        <select
          id="lang"
          name="lang"
          className={classes.dropdown}
          value={selectedLanguage}
          onChange={(event) => {
            dispatch(setLanguage(event.target.value));
          }}
        >
          <option value="4">Swahili</option>
          <option value="0">English</option>
        </select>
      </div>

      {!hide && (
        <>
          <div className={classes.top_menu_items_container}>
            <div
              className={classes.top_navbar_item}
              onClick={() => {
                navigate("/home");
              }}
            >
              <FaHouse
                className={`${classes.top_navbar_icon} ${active === 0 && classes.active}`}
              />
              <p
                className={`${classes.top_navbar_item_name} ${active === 0 && classes.active}`}
              >
                {t("131")}
              </p>
            </div>

            <div
              className={classes.top_navbar_item}
              onClick={() => {
                navigate("/my-matches");
              }}
            >
              <FaFutbol
                className={`${classes.top_navbar_icon} ${active === 1 && classes.active}`}
              />
              <p
                className={`${classes.top_navbar_item_name} ${active === 1 && classes.active}`}
              >
                {t("132")}
              </p>
            </div>

            <div
              className={classes.top_navbar_item}
              onClick={() => {
                navigate("/live");
              }}
            >
              <FaClock
                className={`${classes.top_navbar_icon} ${active === 2 && classes.active}`}
              />
              <p
                className={`${classes.top_navbar_item_name} ${active === 2 && classes.active}`}
              >
                {t("133")}
              </p>
            </div>

            <div
              className={classes.top_navbar_item}
              onClick={() => {
                navigate("/leaderboard");
              }}
            >
              <FaTrophy
                className={`${classes.top_navbar_icon} ${active === 3 && classes.active}`}
              />
              <p
                className={`${classes.top_navbar_item_name} ${active === 3 && classes.active}`}
              >
                {t("134")}
              </p>
            </div>

            <div
              className={classes.top_navbar_item}
              onClick={() => {
                navigate("/profile");
              }}
            >
              <FaUser
                className={`${classes.top_navbar_icon} ${active === 4 && classes.active}`}
              />
              <p
                className={`${classes.top_navbar_item_name} ${active === 4 && classes.active}`}
              >
                {t("135")}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
